/**
 * Design Implementation Domain Errors following GTD clean error handling patterns
 */
export class DesignImplementationDomainError extends Error {
  constructor(
    message: string,
    public readonly code: string,
    public readonly context?: Record<string, any>
  ) {
    super(message);
    this.name = 'DesignImplementationDomainError';
  }
}

export class FlowStateError extends DesignImplementationDomainError {
  constructor(message: string, flowId: string, currentState: string) {
    super(message, 'FLOW_STATE_ERROR', { flowId, currentState });
    this.name = 'FlowStateError';
  }
}

export class ArtifactStateError extends DesignImplementationDomainError {
  constructor(message: string, artifactId: string, currentState: string) {
    super(message, 'ARTIFACT_STATE_ERROR', { artifactId, currentState });
    this.name = 'ArtifactStateError';
  }
}

export class ConformanceValidationError extends DesignImplementationDomainError {
  constructor(message: string, artifactId: string, violations: string[]) {
    super(message, 'CONFORMANCE_VALIDATION_ERROR', { artifactId, violations });
    this.name = 'ConformanceValidationError';
  }
}

export class InvalidScoreError extends DesignImplementationDomainError {
  constructor(score: number, field: string) {
    super(
      `Invalid score value. ${field}: ${score}. Scores must be between 0 and 100.`,
      'INVALID_SCORE_ERROR',
      { score, field, minScore: 0, maxScore: 100 }
    );
    this.name = 'InvalidScoreError';
  }
}

export class ArtifactNotFoundError extends DesignImplementationDomainError {
  constructor(artifactId: string, flowId: string) {
    super(
      `Artifact ${artifactId} not found in flow ${flowId}`,
      'ARTIFACT_NOT_FOUND_ERROR',
      { artifactId, flowId }
    );
    this.name = 'ArtifactNotFoundError';
  }
}